import {
  getSelectionMesh,
  getLoadingMesh,
  drawArea,
  getUnloadedMesh,
  getErrorsMesh,
} from "./selectionBlueprint";
import Color from "../../models/Color";
import colors from "../../../../../../tailwind.colors";

function getDefaultState() {
  return {
    trackRegions: {},
    trackDimensions: [],
    highlightedRegion: [],
    red: new Color(colors.red["500"]),
    gray: new Color(colors.blueGray["700"]),
    blue: new Color(colors.blue["600"]),
  };
}

function selectionTrackController(track) {
  const selectionMesh = getSelectionMesh();
  const loadingMesh = getLoadingMesh();
  const unloadedMesh = getUnloadedMesh();
  const errorsMesh = getErrorsMesh();
  let state = getDefaultState();

  function onReset() {
    state = getDefaultState();
    onPreferencesChanged();
  }

  function extract(x, trackerKey, y0, y1) {
    const tracker = state.trackRegions[x.id]?.[trackerKey];
    const trackAreas = tracker?.areas || [];
    return x.isCollapsed ? [] : trackAreas.map((y) => [...y, x[y0], x[y1]]);
  }

  function update() {
    const { trackDimensions, highlightedRegion } = state;

    const [x0, x1] = highlightedRegion || [];
    const selectionAreas = [
      trackDimensions.map((x) => [x0, x0, x.y0, x.y1])[0] || [],
      trackDimensions.map((x) => [x1, x1, x.y0, x.y1])[0] || [],
    ];

    const loadingAreas = trackDimensions
      .map((x) => extract(x, "loadingTracker", "y0", "y0"))
      .reduce((a, i) => a.concat(i), []);

    const unloadedAreas = trackDimensions
      .map((x) => extract(x, "unloadedTracker", "y0", "y1"))
      .reduce((a, i) => a.concat(i), []);

    const errorAreas = trackDimensions
      .map((x) => extract(x, "errorTracker", "y0", "y1"))
      .reduce((a, i) => a.concat(i), []);

    loadingMesh.setItems(loadingAreas);
    selectionMesh.setItems(selectionAreas);
    unloadedMesh.setItems(unloadedAreas);
    errorsMesh.setItems(errorAreas);

    drawArea(loadingAreas, loadingMesh);
    drawArea(selectionAreas, selectionMesh);
    drawArea(unloadedAreas, unloadedMesh);
    drawArea(errorAreas, errorsMesh);

    track.requestRender();
  }

  function onPreferencesChanged() {
    const config = track.getPreferences();

    const selection = state.red.clone().setOpacity(0.4);
    const error = state.red.clone().setOpacity(0.5);
    const gray = state.gray.clone().setOpacity(config.isDark ? 0.3 : 0.2);

    selectionMesh.uniforms.setColorMap([selection.vec]);
    errorsMesh.uniforms.setColorMap([error.vec]);
    unloadedMesh.uniforms.setColorMap([gray.vec]);
    loadingMesh.uniforms.setColorMap([state.blue.vec]);

    track.requestRender();
  }

  function onRegionStateChange() {
    const { highlightedRegion, regionState } = track.getRegionState();
    state.trackRegions = regionState;
    state.highlightedRegion = highlightedRegion;
    update();
  }

  function onTrackDimensionsChange(dimensions = []) {
    state.trackDimensions = dimensions;
    update();
  }

  return {
    onReset,
    onRegionStateChange,
    onTrackDimensionsChange,
    onPreferencesChanged,
    meshes: [unloadedMesh, errorsMesh, selectionMesh, loadingMesh], //
  };
}

export default selectionTrackController;
